// Set the base URL based on the current location, listening on navigation changes.
import { BasePattern } from "@patternslib/patternslib/src/core/basepattern";
import registry from "@patternslib/patternslib/src/core/registry";
import events from "@patternslib/patternslib/src/core/events";
import logging from "@patternslib/patternslib/src/core/logging";

const log = logging.getLogger("details-navigation");



class Pattern extends BasePattern {
    static name = "parent-click";
    static trigger = ".pat-parent-click";

    init() {
        events.add_event_listener(
            this.el,
            "click",
            "pat-parent-click",
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.el.parentNode.click();
            }
        );
    }
}

registry.register(Pattern);
export default Pattern;
export { Pattern };
